<template>
  <v-form
    ref="inviteeFormRef"
    :id="formId"
    class="form form--with-sticky-actions page-stack grid-stack grid-gap-page-section invitee-form"
    @submit.prevent="submitInviteeForm()"
  >
    <section class="page-panel">
      <header class="page-panel__header">
        <h3 class="panel-title">Podaci uzvanika</h3>
      </header>

      <div class="page-panel__content grid-stack grid-row-gap-18">
        <AppTextField
          v-model="inviteeFormValues.name"
          autocomplete="name"
          class="invitee-form__field"
          label="Ime i prezime"
          required
        />

        <AppTextField
          v-model="inviteeFormValues.company"
          autocomplete="organization"
          class="invitee-form__field"
          label="Tvrtka"
          required
        />

        <AppTextField
          v-model="inviteeFormValues.residence"
          autocomplete="street-address"
          class="invitee-form__field"
          label="Prebivalište"
        />

        <AppTextField
          v-model="inviteeFormValues.email"
          autocomplete="email"
          class="invitee-form__field"
          label="E-mail"
          :disabled="isEditMode"
          :rules="emailRules"
          type="email"
          required
        />

        <AppTextField
          v-model="inviteeFormValues.phone"
          autocomplete="tel"
          class="invitee-form__field"
          label="Telefon"
          type="tel"
        />

        <AppTextField
          v-model="inviteeFormValues.partnerId"
          class="invitee-form__field"
          label="Partner ID"
          type="number"
        />

        <p
          v-if="showEmailNotice"
          class="notice"
        >
          Tri dana prije događaja uzvanik će primiti automatski e-mail s jedinstvenim QR kodom.
          Ako je uzvanik dodan nakon tog roka, e-mail će dobiti odmah nakon spremanja.
        </p>
      </div>
    </section>

    <div class="submit-bar">
      <v-btn
        v-if="showSaveAndAddAnother"
        class="button button--secondary button--toolbar button--full-mobile"
        :disabled="isSavingInvitee"
        type="button"
        variant="outlined"
        @click="submitInviteeForm(true)"
      >
        Prihvati i dodaj novog
      </v-btn>

      <ToolbarActionButton
        :text="submitText"
        type="submit"
        :form="formId"
        icon=""
        :disabled="isSavingInvitee"
        :loading="isSavingInvitee"
      />
    </div>
  </v-form>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'

import AppTextField from './AppTextField.vue'
import ToolbarActionButton from './ToolbarActionButton.vue'

const props = defineProps({
  formId: {
    type: String,
    default: 'invitee-form',
  },

  initialInviteeValues: {
    type: Object,
    default: null,
  },

  submitText: {
    type: String,
    required: true,
  },

  isSavingInvitee: {
    type: Boolean,
    default: false,
  },

  showSaveAndAddAnother: {
    type: Boolean,
    default: false,
  },

  showEmailNotice: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['submit'])

const isEditMode = computed(() => props.initialInviteeValues !== null)

const emailRules = [
  (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? '').trim()) ||
    'Unesite ispravnu e-mail adresu',
]
const inviteeFormRef = ref(null)
const inviteeFormValues = reactive({
  name: props.initialInviteeValues?.name ?? '',
  company: props.initialInviteeValues?.company ?? '',
  residence: props.initialInviteeValues?.residence ?? '',
  email: props.initialInviteeValues?.email ?? '',
  phone: props.initialInviteeValues?.phone ?? '',
  partnerId: props.initialInviteeValues?.partnerId ?? '',
})

async function submitInviteeForm (saveAndAddAnother = false) {
  if (props.isSavingInvitee) {
    return
  }

  const validationResult = await inviteeFormRef.value.validate()

  if (!validationResult.valid) {
    return
  }

  emit('submit', {
    name: inviteeFormValues.name,
    company: inviteeFormValues.company,
    residence: inviteeFormValues.residence,
    email: inviteeFormValues.email.trim().toLowerCase(),
    phone: inviteeFormValues.phone.trim() || null,
    partnerId: inviteeFormValues.partnerId,
  }, saveAndAddAnother)
}
</script>

<style
  scoped
  lang="scss"
>
.invitee-form {
  width: 100%;

  &__field {
    max-width: none;

    @include breakpoint-up("sm") {
      max-width: 560px;
    }
  }

}
</style>
